import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const ProgressWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconWrapper = styled.span`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: ${radius.md};
  color: ${colors.amberDeep};
  background: ${colors.amberSoft};
`;

export const ProgressTitle = styled.p`
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const LevelName = styled.p`
  font-family: ${font.text};
  font-size: 17px;
  font-weight: 800;
  color: ${colors.ink};
`;

export const ProgressText = styled.p`
  font-family: ${font.text};
  font-size: 40px;
  font-weight: 800;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
  color: ${colors.brandDeep};

  span {
    font-size: 16px;
    font-weight: 700;
    color: ${colors.muted};
  }
`;

export const ProgressBar = styled.div`
  height: 10px;
  border-radius: ${radius.pill};
  overflow: hidden;
  background: ${colors.brandSoft};
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, ${colors.brand} 0%, ${colors.amber} 100%);
  transition: width 0.6s ease-out;
`;

export const Hint = styled.p`
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 500;
  color: ${colors.muted};

  b {
    font-weight: 800;
    color: ${colors.ink};
  }
`;
